export default __webpack_public_path__ + "static/media/confinedSpace.c4f2c8df.jpg";